import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Users, CalendarOff, ClipboardCheck, ListChecks } from 'lucide-react';
import { getDashboardStats } from '../../../services/dashboardService';
import StatTileCard from '../../../components/ui/StatTileCard';

// Kullanıcıyla üzerinde anlaşılan dört renk, bu sırayla (spec 2026-08-05-onaylar-paneli,
// Görev 8). Rozetler DÜZ renk, gradyan DEĞİL: bu paleti açık uca doğru gradyanlaştırmak
// kontrastı eşiğin altına düşürüyor (ör. #e76f51 → #F0917A ucunda beyaz ikon 2.32:1 verir).
//
// Safran (#e9c46a) rozetin ikonu KOYU (#264653), beyaz değil: beyaz ikon 1.67:1 ile
// WCAG'ın anlamlı grafik öğeler için eşiği olan 3:1'in altında kalır; koyu ikon 6.03:1'e
// çıkarır. Biri "tutarlı olsun" diye beyaza çevirmek isterse — ÇEVİRME, kontrast eşiğin
// altına düşer. StatsCards.test.js bu kararı kilitler.
export const PALETTE = [
  { background: '#264653', color: '#fff', shadow: '0 2px 8px rgba(38,70,83,.30)' }, // 10.1:1
  { background: '#2a9d8f', color: '#fff', shadow: '0 2px 8px rgba(42,157,143,.30)' }, // 3.32:1
  // Safran: beyaz ikon 1.67:1 ile eşiğin ALTINDA kalırdı — ikon koyu.
  { background: '#e9c46a', color: '#264653', shadow: '0 2px 8px rgba(233,196,106,.38)' }, // 6.03:1
  { background: '#e76f51', color: '#fff', shadow: '0 2px 8px rgba(231,111,81,.30)' }, // 3.09:1
];

const ICONS = [Users, CalendarOff, ClipboardCheck, ListChecks];

// Saf fonksiyon: veri + modül bayraklarından kart listesini üretir. Router'a ya da
// çeviriye bağımlı değildir — bu yüzden StatsCards.test.js router/network kurmadan
// doğrudan sınayabilir. Palet İNDEKSE göre dağıtılır: bir kart modül eksikliğinden
// elenirse kalan kartlar palette'te KAYAR, boşluk kalmaz (ör. ilk iki kart düşerse
// üçüncü kart artık PALETTE[0]'ı taşır).
// Bayraklar kapının ANLAMINI taşır (resolveDashboardGates): "bugün izinde" şirket geneli bir
// yönetim sayısıdır, "aktif anketler" ise kişiye atanmış bekleyen anketlerdir — kişisel.
export function buildStatCards(stats, { canSeeOnLeaveToday, canUseSurveys }) {
  return [
    { key: 'totalEmployees', value: stats.totalEmployees, show: true, path: '/employees' },
    { key: 'onLeaveToday', value: stats.onLeaveToday, show: canSeeOnLeaveToday, path: '/all-leaves' },
    // Artık dokuz kategorinin tamamını kapsıyor (Görev 4), eskiden ikisini sayardı.
    // Eskiden path YOKTU — tıklanmayan ölü bir sayıydı; artık panele gider.
    { key: 'pendingApprovals', value: stats.pendingApprovals, show: true, path: '/approvals' },
    { key: 'activeSurveys', value: stats.activeSurveys, show: canUseSurveys, path: '/my-surveys' },
  ]
    .filter((c) => c.show)
    .map((c, i) => ({ ...c, palette: PALETTE[i % PALETTE.length], icon: ICONS[i % ICONS.length] }));
}

export default function StatsCards({ canSeeOnLeaveToday, canUseSurveys }) {
  const { t } = useTranslation();
  const history = useHistory();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    getDashboardStats().then(res => {
      setStats(res.data?.data);
    });
  }, []);

  if (!stats) return null;

  const cards = buildStatCards(stats, { canSeeOnLeaveToday, canUseSurveys });

  return cards.map((card) => (
    <StatTileCard
      key={card.key}
      icon={card.icon}
      iconBackground={card.palette.background}
      iconColor={card.palette.color}
      iconShadow={card.palette.shadow}
      value={card.value}
      label={t(`dashboard.${card.key}`)}
      onClick={() => history.push(card.path)}
    />
  ));
}
